import { useTranslation } from 'react-i18next';
import Accordion from '../../../../components/Accordion/Accordion';
import Geometry from './Geometry/Geometry';
import HydraulicData from './HydraulicData/HydraulicData';
import Materials from './Materials/Materials';

const InputForm = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className='d-flex flex-column gap-2'>
            <Accordion title={t('input_form_accordion_hydraulic_data')}>
                <HydraulicData />
            </Accordion>
            <Accordion title={t('input_form_accordion_geometry')}>
                <Geometry />
            </Accordion>
            <Accordion title={t('input_form_accordion_materials')}>
                <Materials />
            </Accordion>
        </div>
    );
};

export default InputForm;
